"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vue = _interopRequireDefault(require("vue"));
var _index = _interopRequireDefault(require("../useThrottle/index"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var MIN_DISTANCE = 10;
function getDirection(x, y) {
  if (x > y && x > MIN_DISTANCE) {
    return 'horizontal';
  }
  if (y > x && y > MIN_DISTANCE) {
    return 'vertical';
  }
  return '';
}
function useTouch() {
  var touchData = _vue.default.observable({
    startX: 0,
    // X 初始值
    startY: 0,
    // Y 初始值
    deltaX: 0,
    // X 滑动距离
    deltaY: 0,
    // Y 滑动距离
    offsetX: 0,
    // X 滑动距离绝对值
    offsetY: 0,
    // Y 滑动距离绝对值
    direction: '',
    // 方向：horizontal, vertical
    touching: false //触摸中
  });

  function touchStart(event) {
    resetTouchData();
    touchData.startX = event.touches[0].clientX;
    touchData.startY = event.touches[0].clientY;
  }
  function touchMove(event) {
    var touch = event.touches[0];
    touchData.deltaX = touch.clientX - touchData.startX;
    touchData.deltaY = touch.clientY - touchData.startY;
    touchData.offsetX = Math.abs(touchData.deltaX);
    touchData.offsetY = Math.abs(touchData.deltaY);
    touchData.direction = touchData.direction || getDirection(touchData.offsetX, touchData.offsetY);
  }
  function touchEnd(event) {
    touchData.touching = false;
  }
  function resetTouchData() {
    touchData.direction = '';
    touchData.deltaX = 0;
    touchData.deltaY = 0;
    touchData.offsetX = 0;
    touchData.offsetY = 0;
    touchData.touching = false;
  }
  function _parseArgs(args) {
    var target = document;
    var listener;
    var options = {
      passive: true
    };
    if (typeof args[0] !== 'function') {
      ;
      var _args2 = _slicedToArray(args, 3);
      target = _args2[0];
      listener = _args2[1];
      options = _args2[2];
    } else {
      ;
      var _args3 = _slicedToArray(args, 2);
      listener = _args3[0];
      options = _args3[1];
    }
    return {
      target: target,
      listener: listener,
      options: options
    };
  }
  var onTouchStart = function onTouchStart() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var _parseArgs2 = _parseArgs(args),
      target = _parseArgs2.target,
      listener = _parseArgs2.listener,
      options = _parseArgs2.options;
    var type = 'touchstart';
    var listenerWrap = function listenerWrap(e) {
      touchStart(e);
      if (listener) {
        listener(e);
      }
    };
    target.addEventListener(type, listenerWrap, options);
    return {
      removeEventListener: function removeEventListener() {
        target.removeEventListener(type, listenerWrap, options);
      }
    };
  };
  var onTouchMove = function onTouchMove() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    var _args = args.slice();
    var type = 'touchmove';
    var target = document;
    var listener;
    var options = {
      passive: true
    };
    var delay = 0;
    var noTrailing = false;
    if (_typeof(args[0]) === 'object') {
      target = args[0];
    }
    var lastArg = _args[_args.length - 1];
    if (typeof lastArg === 'boolean') {
      options = lastArg;
      _args.pop();
    }
    while (_args.length) {
      var arg = _args.shift();
      if (arg) {
        if (_typeof(arg) === 'object' && arg.nodeType) {
          target = arg;
        } else if (typeof arg === 'number') {
          delay = arg;
        } else if (typeof arg === 'boolean') {
          noTrailing = arg;
        } else if (typeof arg === 'function') {
          listener = arg;
        } else if (_typeof(arg) === 'object') {
          options = arg;
        }
      }
    }
    var listenerWrap = function listenerWrap(e) {
      touchMove(e);
      if (listener) {
        listener(e);
      }
    };
    if (delay) {
      listenerWrap = (0, _index.default)(delay, noTrailing, function (e) {
        touchMove(e);
        if (listener) {
          listener(e);
        }
      });
    }
    target.addEventListener(type, listenerWrap, options);
    return {
      removeEventListener: function removeEventListener() {
        target.removeEventListener(type, listenerWrap, options);
      }
    };
  };
  var onTouchEnd = function onTouchEnd() {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }
    var _parseArgs3 = _parseArgs(args),
      target = _parseArgs3.target,
      listener = _parseArgs3.listener,
      options = _parseArgs3.options;
    var type = 'touchend';
    var listenerWrap = function listenerWrap(e) {
      touchEnd(e);
      if (listener) {
        listener(e);
      }
    };
    target.addEventListener(type, listenerWrap, options);
    return {
      removeEventListener: function removeEventListener() {
        target.removeEventListener(type, listenerWrap, options);
      }
    };
  };
  return {
    touchData: touchData,
    touchStart: touchStart,
    onTouchStart: onTouchStart,
    touchMove: touchMove,
    onTouchMove: onTouchMove,
    touchEnd: touchEnd,
    onTouchEnd: onTouchEnd,
    resetTouchData: resetTouchData
  };
}
var _default = useTouch;
exports.default = _default;